<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/4 md:w-1/4 lg:w-2/4 xl:w-1/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">

          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-2/4 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <img :src="logoImg" alt="login" class="mx-auto">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>please login to your account.</p>
                </div>

                <login-jwt></login-jwt>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from "./LoginJWT.vue"

export default {
  components: {
    LoginJwt
  },
  computed: {
    logoImg(){
      if(location.host==='ecrm.beegbit.com')
        return '/logo_beegbit.png';
      else if(location.host==='crm.coinreef.com')
        return '/logo_coinreef.png';
      else if(location.host==='crm.sy2.exchange')
        return '/logo_sy2.png';
        else if(location.host==='crm.thebabybunch.io')
          return '/logo_thebabybunch.png';
      else
        return '/logo.png';
    }
  }
}
</script>

<style lang="scss">
.full-page-bg-color-primary{
  background-color: rgb(115, 103, 240);
}
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
